import React, { useContext } from 'react';
import { Grid } from '@material-ui/core';
import styles from './styles.module.css';
import { ShopContext } from '../../../contexts/ShopContext';
import { ROUTES } from '../../../const';
import ViewHelper from '../../../helpers/ViewHelper';
import ShopHelper from '../../../helpers/ShopHelper';
import { getDateString } from '../../../helpers/DateFormatHelper';
import DateTimeHelpers from '../../../helpers/DateTimeHelpers';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { CartContext } from '../../../contexts/CartContext';

export default function OrderView({ order, showDetailsPage = false }) {
  const { shop } = useContext(ShopContext);
  const { reOrder } = useContext(CartContext);
  const history = useHistory();

  const openOrderDetailsPage = () => {
    if (!showDetailsPage) return;
    const orderDetailsPath = ROUTES.ORDER_DETAILS.replace(':shopId', shop?.shopId).replace(':orderId', order.id);
    history.push(orderDetailsPath);
  };

  return (
    <Grid item xs={12} sm={6} md={4}>
      <div className={styles.productCard} onClick={openOrderDetailsPage}>
        <div className={styles.productInfoParent}>
          <div className={styles.imageContainer}>
            {order.details.items.length === 1 ? (
              <img className={styles.productImage} src={order.details.items[0]?.image} alt="" />
            ) : order.details.items.length === 2 ? (
              <>
                <img className={styles.productImage} src={order.details.items[0]?.image} alt="" />
                <div className={styles.overlayWrapper}>
                  <img
                    className={`${styles.productImage} ${styles.overlayImage}`}
                    src={order.details.items[1]?.image}
                    alt=""
                  />
                </div>
              </>
            ) : (
              <>
                <img className={styles.productImage} src={order.details.items[0]?.image} alt="" />
                <div className={styles.overlayWrapper}>
                  <img
                    className={`${styles.productImage} ${styles.overlayImage}`}
                    src={order.details.items[1]?.image}
                    alt=""
                  />
                </div>
                <div className={styles.moreItems}>+{order.details.items.length - 2}</div>
              </>
            )}
          </div>
          <div className={styles.productInfo}>
            <span className={styles.title}>
              {order.details.items.length === 1
                ? ViewHelper.toTitleCase(order.details.items[0]?.name)
                : `${order.details.items.length} Items`}
            </span>
            <span className={styles.text}>{getDateString(order.created_at)}</span>
            <span className={styles.text}>Transaction ID: {order.id}</span>
          </div>
        </div>
        <div className={styles.endWrapper}>
          <span className={styles.head}>
            {ShopHelper.getShopCurrency(shop)} {order.details.amount}
          </span>
          {!DateTimeHelpers.isToday(order.created_at) && (
            <div
              className={styles.btn}
              onClick={(e) => {
                e.stopPropagation();
                reOrder(shop?.shopId, order.id);
                history.push(ROUTES.CART.replace(':shopId', shop.shopId));
              }}
            >
              Re Order
            </div>
          )}
        </div>
      </div>
    </Grid>
  );
}
